export function sum(arr) {
    var num = 0;
    for (var i=0; i<arr.length; i++) num += arr[i];
    return num;
}

export function getParameterByName(name) {
    var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

export function pick(obj, ...keys) {
    if (obj == null) return {};
    var result = {};

	for (var i = 0, length = keys.length; i < length; i++) {
		var key = keys[i];
        if (key in obj) result[key] = obj[key];
	}
    return result;
}

export function required() {
    return <abbr className="required" title="required">*</abbr>;
}

function isElementInViewport (el, minHeight = 20, minWidth = 0) {
    var rect = el.getBoundingClientRect();

    return (rect.bottom >= minHeight  &&
        rect.right >= minWidth &&
            rect.top <= (window.innerHeight || document.documentElement.clientHeight) - minHeight &&
            rect.left <= (window.innerWidth || document.documentElement.clientWidth) - minWidth);
}

export function scrollToErrors() {
    var el = $('.text-danger').closest('.form-group').addBack().get(0);
    if (el && !isElementInViewport(el)) el.scrollIntoView();
}

import update from 'react-addons-update';

export function bindState(property, filter, callback) {
    var keys = property.split('.');

    var getValue = event => {
        var value = (event => {
            var el = event.target;
            if (el.tagName === 'TEXTAREA' || (el.tagName === 'INPUT' && /^(?:text|hidden|password)$/.test(el.type))) {
                return el.value;
            } else if (el.tagName === 'INPUT' && el.type === 'checkbox') {
                return el.checked;
            } else if (el.tagName === 'INPUT' && el.type === 'radio') {
                return el.value;//el.checked;
            } else if (el.tagName === 'SELECT')
                return el.value;
        })(event);
        return filter ? filter(value) : value;
    }

    return (event) => {
        var op = keys.slice(1).reverse().reduce((prev, next) => ({[next] : prev}), {$set: getValue(event)});
        this.setState({
            [keys[0]]: update(this.state[keys[0]], op)
        }, callback);
    };
}

export function renderErrors2(errs, field) {
    if (!errs) return;

    var isOverall = Array.isArray(errs) || typeof errs === 'string',
        errors;

    if (field === '_overall_') errors = isOverall ? errs : errs['_overall_'];
    else errors = isOverall ? [] : errs[field];

    if (!Array.isArray(errors)) errors = errors === undefined ? [] : [errors];

    return errors.length ?
        <div className="text-danger">
            <ul>
                { errors.map((err, i) => <li key={i}>{ err }</li>) }
            </ul>
        </div>
        : null;
}

export function renderErrors(errors) {
    return errors ?
        <div className="text-danger">
            <ul>
                { Array.isArray(errors) ? errors.map((err, i) => <li key={i}>{ err }</li>) : <li>{errors}</li> }
            </ul>
        </div>
        : null;
}

export var productImageBaseUrl = '/media/images/products/';

export function getProductImageUrl(image_file, size) {
    if (!size) size = 'md';
    return image_file ? productImageBaseUrl + size + '/' + image_file : null;
}

// get images for child products or non-variant products.
export function getImageUrlForProduct(p, size) {
    var images = p.images && p.images.length ? p.images : p.parent_images || [];
    return getProductImageUrl(images.length ? images[0] : null, size);
}

export function escapeHtml(unsafe) {
    return unsafe
         .replace(/&/g, "&amp;")
         .replace(/</g, "&lt;")
         .replace(/>/g, "&gt;")
         .replace(/"/g, "&quot;")
         .replace(/'/g, "&#039;");
 }


export function baseModal(options) {
    var tmpt = `<div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="confirm">
  <div class="modal-dialog ${options.size ? 'modal-' + options.size : ''}" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <h4 class="modal-title">${escapeHtml(options.title)}</h4>
      </div>
      <div class="modal-body">
        ${options.content}
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default" data-dismiss="modal">${options.closeButton || 'Close'}</button>
        ${options.confirmButton ? '<button type="button" class="btn btn-primary">' + options.confirmButton + '</button>' : ''}
      </div>
    </div>
  </div>
</div>`;
        var el = $(tmpt).appendTo($('body'))
        .on('hidden.bs.modal', function() {
            el.remove();
        });
    $('.btn-primary', el).click(function() {
        options.callback(el, options);
    });
    setTimeout(function() {
        el.modal({show: true});
    }, 0);
}

export function confirmModal(options) {
    baseModal(Object.assign({confirmButton: 'OK', closeButton: 'Cancel'}, options));
}

export var alertModal = baseModal;


$(function() {
    var heightDiff = $(window).height() - $('body').height();
    if (heightDiff > 0) {
        var currMarginTop = parseInt($('#footer-container').css('margin-top'));  // .css always returns sizes in pixels.
        $('#footer-container').css( 'margin-top',  currMarginTop + heightDiff );
    }
});
